import React from "react";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";


const Others = () => {
 


  return (
      <div className="body_wrapper">
          <CustomNavbar
        slogo="sticky_logo"
        mClass="menu_four"
        nClass="w_menu ml-auto mr-auto"
      />
      <Breadcrumb
        breadcrumbClass="breadcrumb_area"
        imgName="breadcrumb/banner_bg.png"
        Ptitle="Our Products"
        Pdescription=""
      />
    <section className="contact_info_area sec_pad bg_color">
        
      <div className="container">
        <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Our Products</h6>
        <div className="text-center my-5">
            <img alt="All Products" src = {require ("../img/our_products.jpg")} />
            </div>


        
      </div>
      <FooterTwo FooterData={FooterData} />
    </section>
    </div>
  );
};

export default Others;
